import AllItemsActions from 'sharedreact/actions/AllItemsActions';

function update (): void {
  AllItemsActions.refresh();
}

export default {
  update
};
